import type { IUserPreferenceService } from './IUserPreferenceService';
import type { IServicesCollection } from 'src/packages/di';

import { UserPreferenceService } from './UserPreferenceService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    userPreference: IUserPreferenceService;
  }
}

export async function addUserPreferenceService(di: IServicesCollection) {
  const userPreferenceService = new UserPreferenceService();
  await userPreferenceService.loadPreferences();

  di.addSingleton('userPreference', userPreferenceService);
}
